import { render, staticRenderFns } from "./getApproved.vue?vue&type=template&id=286d822c&scoped=true&"
import script from "./getApproved.vue?vue&type=script&lang=js&"
export * from "./getApproved.vue?vue&type=script&lang=js&"
import style0 from "./getApproved.vue?vue&type=style&index=0&id=286d822c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286d822c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
